'use client';

import { Chip } from '@yanolja-rnd/nol-design-system';
import { yaNative } from '@weberus/ui/utils/ya-native';
import { useImpressionLog } from '@/app/_shared/hooks/use-impression-log';
import config from '@/conf';

interface RelatedKeywordProps {
  title?: string;
  items?: string[];
  onImpression?: () => void;
  onClick?: (keyword: string) => void;
}

export const RelatedKeyword = ({ title, items, onImpression, onClick }: RelatedKeywordProps) => {
  const ref = useImpressionLog(() => {
    if (onImpression) {
      onImpression();
    }
  });
  const handleItemClick = (keyword: string) => {
    if (onClick) {
      onClick(keyword);
    }
    const url = `${config.service.home.origin}/results?keyword=${encodeURIComponent(keyword)}&category=local`;
    if (yaNative.isEnabled) {
      yaNative.wv({ url, previousWebDismiss: 1 });
    } else {
      window.location.replace(url);
    }
  };

  return (
    <div ref={ref} className="mb-20 mt-8 flex h-full w-full flex-col justify-center px-16 pc:px-0">
      <div className="flex min-h-50 w-full items-center">
        <span className="typography-subtitle-18-bold">{title}</span>
      </div>
      <div className="flex flex-wrap gap-6">
        {items?.map((keyword) => (
          <Chip key={keyword} onClick={() => handleItemClick(keyword)}>
            {keyword}
          </Chip>
        ))}
      </div>
    </div>
  );
};
